var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBowmerKirklandLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.546,
    height: 34.77,
    viewBox: "0 0 110.546 34.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28845",
    "data-name": "Group 28845",
    transform: "translate(-894 -56.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140127",
    "data-name": "Path 140127",
    d: "M-4.057-9.335h-6.719V-24.8h6.409c3.219,0,4.933,1.8,4.933,4.475a3.7,3.7,0,0,1-1.7,3.057A3.58,3.58,0,0,1,.772-13.9c0,2.953-2.069,4.563-4.829,4.563m-.562-12.051H-6.98v2.51h2.361A1.2,1.2,0,0,0-3.245-20.13a1.2,1.2,0,0,0-1.374-1.255m.192,5.922H-6.98v2.717h2.569A1.276,1.276,0,0,0-3.024-13.9a1.35,1.35,0,0,0,0-.219,1.268,1.268,0,0,0-1.4-1.344Z",
    transform: "translate(917.373 81.694)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140128",
    "data-name": "Path 140128",
    d: "M-6.17-8.446a6.244,6.244,0,0,1-8.654,0c-1.624-1.624-1.565-3.8-1.565-6.129s-.059-4.49,1.565-6.129a5.747,5.747,0,0,1,4.342-1.727,5.67,5.67,0,0,1,4.328,1.742c1.624,1.624,1.565,3.8,1.565,6.129s.057,4.49-1.581,6.114M-8.961-18.37a2.042,2.042,0,0,0-2.884-.158A2.109,2.109,0,0,0-12-18.37c-.355.457-.561.975-.561,3.8s.221,3.322.561,3.779a2.014,2.014,0,0,0,2.841.2,2.047,2.047,0,0,0,.2-.2c.354-.457.561-.96.561-3.779s-.221-3.338-.561-3.8",
    transform: "translate(935.82 79.196)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140130",
    "data-name": "Path 140130",
    d: "M-9.477,0-11.5,8.167-14,0h-2.688l-2.5,8.167L-21.2,0h-3.973l4.253,15.462h3.087l2.5-7.62,2.5,7.62h3.1L-5.5,0Z",
    transform: "translate(956.42 56.897)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140131",
    "data-name": "Path 140131",
    d: "M-6.445,0l-3.47,6.823L-13.386,0h-3.736V15.447h3.794v-7.4l2.2,3.825H-8.7l2.2-3.825v7.414h3.795V0Z",
    transform: "translate(968.778 56.897)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140132",
    "data-name": "Path 140132",
    d: "M0,0V15.452H10.516V12.068H3.811V9.352H9.541V5.968H3.811V3.383h6.706V0ZM0,15.452v.01Z",
    transform: "translate(968.388 56.897)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140133",
    "data-name": "Path 140133",
    d: "M-4.716-9.335-7.449-15.1H-8.733v5.761h-3.8V-24.8H-6.4A4.944,4.944,0,0,1-1.127-19.82a4.456,4.456,0,0,1-2.527,4.046L-.315-9.321h-4.4ZM-6.576-21.385H-8.732v3.131h2.156a1.567,1.567,0,0,0,1.65-1.481,1.568,1.568,0,0,0-1.481-1.65,1.527,1.527,0,0,0-.169,0",
    transform: "translate(993.292 81.694)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140135",
    "data-name": "Path 140135",
    d: "M-4.966,0-9.441,5.479V0h-3.751V15.462h3.751V10.619l1.3-1.492,3.559,6.335v.015H-.138L-5.587,6.262-.314,0Z",
    transform: "translate(919.789 76.052)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140136",
    "data-name": "Path 140136",
    d: "M42.3-9.359h3.8V-24.821H42.3Z",
    transform: "translate(878.077 100.873)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140137",
    "data-name": "Path 140137",
    d: "M-4.716-9.335-7.448-15.1H-8.733v5.761h-3.8V-24.8H-6.4A4.944,4.944,0,0,1-1.127-19.82a4.455,4.455,0,0,1-2.525,4.046L-.314-9.32h-4.4ZM-6.576-21.385H-8.732v3.131h2.156a1.561,1.561,0,0,0,1.651-1.465c0-.034,0-.067,0-.1a1.578,1.578,0,0,0-1.589-1.567l-.065,0Z",
    transform: "translate(939.019 100.849)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140139",
    "data-name": "Path 140139",
    d: "M-4.966,0-9.44,5.479V0h-3.751V15.462H-9.44V10.619l1.3-1.492,3.559,6.335v.015H-.137L-5.587,6.262-.313,0Z",
    transform: "translate(953.017 76.052)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140140",
    "data-name": "Path 140140",
    d: "M0,0V15.462H10.294V12.08H3.8V0Z",
    transform: "translate(953.605 76.052)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140141",
    "data-name": "Path 140141",
    d: "M-3.4,0-9.023,15.462h3.971l.753-2.3H.458l.724,2.3H5.169L-.458,0Zm1.565,5.863,1.3,4.12H-3.22Z",
    transform: "translate(972.758 76.052)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140142",
    "data-name": "Path 140142",
    d: "M-4.992,0V7.768L-9.94,0h-3.322V15.462h3.795V7.694l4.947,7.768H-1.2V0Z",
    transform: "translate(991.928 76.052)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140143",
    "data-name": "Path 140143",
    d: "M-5.973-8.416A5.767,5.767,0,0,1-10.138-6.9h-5.73V-22.357h5.731a5.741,5.741,0,0,1,4.165,1.521c1.8,1.8,1.61,3.779,1.61,6.218s.191,4.4-1.611,6.2m-2.6-9.688a2,2,0,0,0-1.831-.871h-1.669v8.684H-10.4a2,2,0,0,0,1.831-.871c.31-.428.413-.842.413-3.471,0-2.6-.119-3.042-.413-3.471",
    transform: "translate(1008.903 98.409)",
    fill: "#0f1b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140145",
    "data-name": "Path 140145",
    d: "M-2.2,0V3.648H-5.85V7.354H-2.2V11H1.5V7.354H5.153V3.648H1.5V0Z",
    transform: "translate(899.85 68.727)",
    fill: "#e01c47"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowmerKirklandLogo);
export default __webpack_public_path__ + "static/media/bowmer-kirkland-logo.9c3fbed627ee58c3f3dbb3cce8e90967.svg";
export { ForwardRef as ReactComponent };